import styles from './MainPage.module.css'
import back from '../../assets/img/mainPagePhoto.jpg'
import { useNavigate } from 'react-router-dom'
import PATH from '../../navigation/path'
import NavbarMain from '../../components/NavbarMain/NavbarMain'
import CustomButton from '../../components/UI/CustomButton/CustomButton'

export type EventType = {
  id: number
  title: string
  subTitle: string
  numberOfPerson: string
  images: ImageType[]
}

export type ImageType = {
  id: number
  src: string
}

const MainPage = () => {
  const navigate = useNavigate()

  const handleNavigate = () => {
    navigate(PATH.registrationPage)
  }
  const handleNavigateToReg = () => {
    navigate(PATH.authPage)
  }

  return (
    <div className={styles.mainPage}>
      <NavbarMain />
      <div className={styles.mainPageContainer}>
        <div className={styles.centralMainBlock}>
          <div className={styles.centralLeft}>
            <div className={styles.leftTop}>
              <h1>
                <span>miceconnect </span> — ключ к идеальному управлению <br />
                MICE-площадкой
              </h1>
            </div>
            <div className={styles.leftBot}>
              <div className={styles.botTextes}>
                <p>
                  {`Бронируйте онлайн в пару кликов, отслеживайте аналитику в реальном времени и открывайте доступ к календарю 
для клиентов по всему миру.`}
                </p>
                <p>{`Упрощайте рутину, увеличивайте загрузку 
и максимизируйте выручку.`}</p>
              </div>
              <div className={styles.authButton}>
                <CustomButton
                  className={styles.regButton}
                  title='Зарегистрироваться'
                  onClick={() => handleNavigate()}
                />
                <CustomButton
                  className={styles.signIn}
                  title='Войти'
                  onClick={() => handleNavigateToReg()}
                />
              </div>
            </div>
          </div>
          <div className={styles.centralRight}>
            <img src={back} alt='' />
          </div>
        </div>
      </div>
    </div>
  )
}

export default MainPage
